module.exports = __webpack_public_path__ + "img/emitHairstyleeditor01.f8aae6c4.png";